import React from 'react';
import { Button } from '@mui/material';
import { CARRIER_TYPE } from 'commons/constants';

export const Columns = (deleteCarrierItem) => [
  {
    id: 'code',
    numeric: false,
    disablePadding: false,
    label: 'Mã',
    width: 10,
    sort: true,
    align: 'center',
  },
  {
    id: 'name',
    numeric: true,
    disablePadding: false,
    label: 'Tên hãng tàu/ hàng không',
    align: 'center',
  },
  {
    id: 'phone',
    numeric: true,
    disablePadding: false,
    label: 'SĐT',
    align: 'center',
  },
  {
    id: 'address',
    numeric: true,
    disablePadding: false,
    label: 'Địa chỉ',
    align: 'center',
  },
  {
    id: 'isCarrier',
    numeric: true,
    disablePadding: false,
    label: 'Đơn vị vận chuyển',
    align: 'center',
    render: (value) => CARRIER_TYPE[value?.isCarrier],
  },
  {
    id: 'actions',
    numeric: false,
    disablePadding: false,
    label: 'Thao tác',
    width: '10px',
    fixed: 'right',
    align: 'center',
    render: (row) => (
      <Button
        variant="contained"
        size="small"
        color="error"
        sx={{ borderRadius: '15px', textTransform: 'none' }}
        onClick={() => window.showConfirm(() => deleteCarrierItem(row))}
      >
        Xoá
      </Button>
    ),
  },
];
